import { put } from 'redux-saga/effects'
import debug from 'Helper/debugHelpers'
import globalConfig from 'Helper/configHelpers'
import { handleSequentialRequest } from './apiRequestTypes'

export function* closeEncounter(action) {
  const encounterId = action.encounterId
  if (encounterId == null) {
    const resource =
      'patient/' +
      action.patientId +
      '/encounter?sort=' +
      encodeURI(JSON.stringify([{ loginTime: 'desc' }]))
    const search = { not_equal: { state: 'logged_out' } }
    debug.log(
      'making search API call to ' + globalConfig.api_base_url + '/v1/' + resource,
      debug.logLevels.API
    )
    const result = yield handleSequentialRequest({
      method: 'search',
      resource,
      obj: search
    })
    if (result[0] != undefined) {
      // call an action to make an API call to close the encounter
      yield put({
        type: 'XTRACT_API_CALL',
        resource: 'v1/patient/' + action.patientId + '/encounter',
        method: 'update',
        obj: { state: 'logged_out' },
        id: result[0].encounter_id
      })
    }
  }
}
